import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        '& .MuiAutocomplete-popupIndicator': {
            marginRight: '25px',
        },
    },
    icon: {
        fill: 'none',
        stroke: '#53759B',
        strokeWidth: '2px',
    },
    inputWrapper: {
        padding: '20px 35px 6px',
    },
    inputField: {
        '&:first-child': {
            padding: '2px 0px!important',
        },
    },
    listBox: {
        color: theme.palette.primary.light,
        fontSize: theme.typography.pxToRem(18),
        fontWeight: 300,
    },
    textHighlight: {
        fontWeight: 600,
    },
    options: {
        padding: '6px 16px',
        '&:hover, &[data-focus="true"]': {
            backgroundColor: theme.palette.text.primary,
            color: theme.palette.primary.contrastText,
        },
    },
    paper: {
        boxShadow: 'none',
        borderRadius: 0,
        border: '1px solid #CAD7E0',
    },
}));
